import wsStorage, { WS_STORAGE_KEY } from "lib/wsStorage";

export const getKioskName = () => wsStorage.getItem(WS_STORAGE_KEY.KIOSK_NAME);

export const setKioskName = (name) => wsStorage.setItem(WS_STORAGE_KEY.KIOSK_NAME, name);

export const getKioskDeviceID = () => wsStorage.getItem(WS_STORAGE_KEY.KIOSK_DEVICE_ID);

export const setKioskDeviceID = (deviceID) => {
    if (deviceID !== null) {
        wsStorage.setItem(WS_STORAGE_KEY.KIOSK_DEVICE_ID, deviceID);
    }
};
